import { useCallback, useMemo } from 'react';

import {
  useRfqBuilderActions,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';
import { useRfqBuilderLegView } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/leg-view';

import TransparentSelectField from '#/components/UnifiedRfqs/components/TransparentSelectField';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { FormOption } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/types';

export default function ProductSelector() {
  const { index, product, isHedge } = useRfqBuilderLegView();
  const { selectLegProduct } = useRfqBuilderActions();
  const { strategy, strategyShortcut } = useRfqBuilderView();
  const trackAction = useTrackAction();
  const isMobile = useIsMobile();
  const width = isMobile ? 'auto' : 190;
  const menuWidth = isMobile ? 'auto' : 220;
  const strategyCode =
    strategyShortcut.selectedOption?.value ??
    strategy.selectedOption?.value ??
    null;

  const handleOnChange = useCallback(
    (option: FormOption<string> | null) => {
      trackAction('update strategy leg', {
        strategyCode,
        productCode: option?.value ?? null,
        isHedge,
      });
      if (option != null) selectLegProduct(index, option.value);
    },
    [index, selectLegProduct, strategyCode, trackAction, isHedge],
  );

  return useMemo(
    () => (
      <TransparentSelectField
        aria-label="Select product"
        isDisabled={product.isDisabled}
        noOpacity
        width={width}
        menuWidth={menuWidth}
        options={product.options}
        value={product.selectedOption}
        invalid={!product.isValid}
        onChange={handleOnChange}
        isSearchable={!isMobile}
      />
    ),
    [
      product.isDisabled,
      product.options,
      product.selectedOption,
      product.isValid,
      width,
      menuWidth,
      handleOnChange,
      isMobile,
    ],
  );
}
